export default {"src":"/_next/static/media/ic-clipboard-2.14a6e409.svg","height":28,"width":29};